"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseClass_1 = __importDefault(require("./BaseClass"));
/**
 * Class contain function wrapper for Service API Key API
 * @public
 */
class ServiceAPIKey extends BaseClass_1.default {
    constructor(apiV1, apiV2) {
        super(apiV1, apiV2);
    }
    /**
     * Get list API Key of service
     * @param serviceId - service Id
     * @param page - page number
     * @param limit - limit number
     * @returns list of API Key in service
     */
    async getListAPIKey(serviceId, page = 0, limit = 10) {
        try {
            const data = await this._apiV2.apiKeyAPI.getListAPIKey(serviceId, page, limit);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Create new API KEY for Service
     * @param serviceId - service Id
     * @param payload - api key payload. E.g: {"description":"test","scopes":[]}
     * @returns
     */
    async createAPIKey(serviceId, payload) {
        try {
            const data = await this._apiV2.apiKeyAPI.createAPIKey(serviceId, payload);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Update existing API KEY
     * @param serviceId - service Id
     * @param apiKeyId - api key Id
     * @param payload - payload. E.g: { active:true, scopes: [], description: 'test desc'}
     * @returns
     */
    async updateAPIKey(serviceId, apiKeyId, payload) {
        try {
            const data = await this._apiV2.apiKeyAPI.updateAPIKey(serviceId, apiKeyId, payload);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Delete an API Key in service
     * @param serviceId - service id
     * @param apiKeyId - api key id
     * @returns
     */
    async deleteAPIKey(serviceId, apiKeyId) {
        try {
            const data = await this._apiV2.apiKeyAPI.deleteAPIKey(serviceId, apiKeyId);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
}
exports.default = ServiceAPIKey;
